import React from "react";
import { StepIndicator } from "@telia/teddy";
import classnames from "classnames";
import { connect } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import { ONBOARDING_B2B_LINKS, ONBOARDINGB2B_LABELS } from "../../../../../../constants";
import { RootState } from "../../../../../../models";
import { isBankIdVerified as isBankIdVerifiedSelector } from "../../../../authentication/state/selectors";
import { ConnectedAlert, ProgressBar } from "../../../../components";
import { selectors as LOADING_SELECTORS } from "../../../../loading";
import { isOrderFound as getIsOrderFound } from "../../../state/selectors";
import "./OnboardingB2BPage.less";
import ContinueSection from "../../molecules/ContinueSection/ContinueSection";

function locationToStepIndicatorIndex(path: (typeof ONBOARDING_B2B_LINKS)[number]) {
    const index = ONBOARDING_B2B_LINKS.indexOf(path);
    return Math.max(index, 0);
}
interface OnboardingB2BPageProps {
    className?: string;
    isBankIdVerified: boolean;
    isFetchingData: boolean;
    isOrderFound: boolean;
}

const OnboardingB2BPage: React.FC<OnboardingB2BPageProps> = ({
    className = "",
    isBankIdVerified,
    isFetchingData,
    isOrderFound,
}) => {
    const location = useLocation();

    return (
        <div
            className={classnames("onboarding-b2b-page", {
                [className]: className,
            })}
        >
            {isOrderFound && (
                <div className="onboarding-b2b-page__step-indicator" data-cy="onboarding-b2b-step-indicator">
                    <StepIndicator
                        index={locationToStepIndicatorIndex(location.pathname as (typeof ONBOARDING_B2B_LINKS)[number])}
                        numberOfSteps={5}
                        labels={ONBOARDINGB2B_LABELS}
                        links={ONBOARDING_B2B_LINKS}
                        kind="purple"
                    />
                </div>
            )}
            <ProgressBar isFetchingData={isFetchingData} backgroundColor="white" />
            <ConnectedAlert />
            <div className="onboarding-b2b-page__content">
                <Outlet />
                {isBankIdVerified && <ContinueSection path={location.pathname} />}
            </div>
        </div>
    );
};

const mapStateToProps = (state: RootState) => ({
    isBankIdVerified: isBankIdVerifiedSelector(state),
    isFetchingData: LOADING_SELECTORS.isLoading(state),
    isOrderFound: getIsOrderFound(state),
});

export default connect(mapStateToProps)(OnboardingB2BPage);
